/**
 * Đường dẫn → phạm vi cổng.
 *
 * Từ ADR-UI-0012 sửa lần 1, mỗi cổng có nhánh URL riêng (`/admin`, `/client`)
 * nên phạm vi của một đường dẫn **đọc thẳng từ tiền tố**, không phải tra bảng.
 * Nhờ vậy không còn chuyện `/nhat-ky` và `/nhat-ky/thao-tac` tranh nhau: hai
 * màn đó giờ là `/admin/nhat-ky` và `/client/nhat-ky/thao-tac`.
 */
import { laDungChung, tach } from './duong-dan-cong';
import type { PhamViCong } from './pham-vi-cong';

/**
 * Phạm vi của một đường dẫn; `undefined` nghĩa là dùng chung cho cả hai cổng.
 *
 * Đường dẫn không mang tiền tố trả `undefined`: đó là đường dẫn cũ hoặc gõ
 * sai, và `ChuyenHuongCong` lo đưa nó về đúng nhánh — chặn bằng màn báo lỗi sẽ
 * làm hỏng mọi dấu trang có từ trước.
 */
export function phamViCuaRoute(pathname: string): PhamViCong | undefined {
  if (laDungChung(pathname)) return undefined;
  return tach(pathname).phamVi;
}

/**
 * Người ở cổng `cua` có được vào đường dẫn thuộc cổng `cua Route` không.
 *
 * **Không đối xứng, có chủ đích**: nhân sự nền tảng xem được giao diện tenant
 * để dựng và để hỗ trợ khách hàng, còn tài khoản tenant không bao giờ sang
 * được cổng quản trị.
 *
 * ⚠️ Chiều mở này chỉ là điều hướng giao diện. Nhân sự nền tảng không thuộc
 * tenant nào nên màn nghiệp vụ họ mở ra sẽ rỗng; dữ liệu thật vẫn do Gateway
 * chặn theo token (ADR-0007).
 */
export function duocVaoCong(cuaNguoiDung: PhamViCong, cuaRoute: PhamViCong): boolean {
  if (cuaNguoiDung === cuaRoute) return true;
  return cuaNguoiDung === 'nen-tang' && cuaRoute === 'tenant';
}
